import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { batchUpdateLogs, setFetching, upsertLogs } from 'models/userActivityLog';
import reportFirestore from 'network/reportFirestore';

const UserActivityLogObserver: FC<{ boothId: string; filter: any; activityLogTarget: any }> = ({ boothId, filter, activityLogTarget }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFetching(true));
    dispatch(batchUpdateLogs([]));
    let query = reportFirestore
      .collection('BoothActivity')
      .where('booth_id', '==', boothId);

    if (filter) {
      query = query
        .where('event_type', '==', filter.value);
    }

    if (activityLogTarget) {
      query = query
        .where(activityLogTarget.type, '==', activityLogTarget.value);
    }
    query = query
      .orderBy('action_at', 'desc')
      .limit(100);

    const observer = query.onSnapshot(
      (querySnapshot) => {
        dispatch(setFetching(false));
        const freshLogs = querySnapshot.docChanges().filter((change) => change.type === 'added').map((change) => ({
          id: change.doc.id,
          ...change.doc.data(),
        }));
        dispatch(upsertLogs(freshLogs));
      },
      (err) => {
        console.log(`Encountered error: ${err}`);
      },
    );
    return () => {
      observer();
      dispatch(batchUpdateLogs([]));
      dispatch(setFetching(true));
    };
  }, [dispatch, filter, activityLogTarget, boothId]);

  return null;
};

export default React.memo(UserActivityLogObserver);
